import {observer} from "mobx-react";
import {useState, useEffect} from "react";
import {GameJackpotBarAmountBox} from "./boxes/prizes/amount/game-jackpot-bar-amount.box";
import {GameJackpotBarLabelBox} from "./boxes/prizes/label/game-jackpot-bar-label.box";
import {GameJackpotBarSectionContainerBox} from "./boxes/containers/game-jackpot-bar-section-container.box";
import {IAvailablePrizes} from "./interfaces/game-jackpot-bar-available-prizes-data";
import {GameJackpotBarLogoBox} from "./boxes/logo/game-jackpot-bar-logo.box";

interface IGameJackpotBarPrizesComponentProps {
    currentPrize: IAvailablePrizes | undefined;
    isOptInStatus: boolean;
    isMobilePortrait: boolean;
}

export const GameJackpotBarPrizesComponent: React.FC<IGameJackpotBarPrizesComponentProps> = observer((props) => {
    const [label, setDisplayedText] = useState(props.currentPrize?.label);
    const [amount, setDisplayedAmount] = useState(props.currentPrize?.amount);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        // Only animate if the label value changes alongside amount value
        if (props.currentPrize?.label !== label) {
            setIsVisible(false);

            const timeout1 = setTimeout(() => {
                setDisplayedText(props.currentPrize?.label);
                setDisplayedAmount(props.currentPrize?.amount);
                setIsVisible(true);
            }, 200);

            return () => clearTimeout(timeout1);
        } 
    }, [props.currentPrize?.amount, props.currentPrize?.label, label]);

    return (
        <GameJackpotBarSectionContainerBox className={isVisible ? "fade-in" : "fade-out"}>
            {props.isMobilePortrait && !props.currentPrize ?
                <GameJackpotBarLogoBox isMobilePortrait={props.isMobilePortrait} /> :
                <>
                    <GameJackpotBarAmountBox isOptInStatus={props.isOptInStatus} className={'cy-jp-bets-game-bar-prize-amount'}>{amount}</GameJackpotBarAmountBox>
                    <GameJackpotBarLabelBox>{label}</GameJackpotBarLabelBox>
                </>
            }
        </GameJackpotBarSectionContainerBox>
    );
});